import { Box } from "@mui/joy";
import DarkTypography from "../../common/DarkTypography";

export type TrainingsEmptyStateProps = {
  message: string;
  dense?: boolean;
};

export default function TrainingsEmptyState({ message, dense = false }: TrainingsEmptyStateProps) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        py: dense ? 2 : { xs: 3, sm: 4 },
        px: 2,
        boxSizing: "border-box",
      }}
    >
      <DarkTypography level="h4" colorVariant="primary" sx={{ textAlign: "center", maxWidth: 560 }}>
        {message}
      </DarkTypography>
    </Box>
  );
}
